import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaBell } from "react-icons/fa";
import notificationApi from "../../../api/notificationApi";
import "./NotificationBell.css";

const NotificationBell = ({ isAuthenticated }) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  const unread = useMemo(() => notifications.filter((n) => !n.isRead).length, [notifications]);

  const loadNotifications = useCallback(async () => {
    if (!isAuthenticated) return;
    try {
      setLoading(true);
      const res = await notificationApi.list();
      setNotifications(res.data?.notifications || []);
      setUnreadCount(res.data?.unreadCount || 0);
    } catch (err) {
      // Silent fail in header component.
    } finally {
      setLoading(false);
    }
  }, [isAuthenticated]);

  useEffect(() => {
    loadNotifications();
    const timer = setInterval(loadNotifications, 30000);
    return () => clearInterval(timer);
  }, [isAuthenticated, loadNotifications]);

  if (!isAuthenticated) return null;

  const handleOpen = () => {
    setOpen((prev) => !prev);
    if (!open) loadNotifications();
  };

  const markAndNavigate = async (notification) => {
    try {
      if (!notification.isRead) {
        await notificationApi.markRead(notification._id);
      }
      await loadNotifications();
      setOpen(false);
      if (notification.link) navigate(notification.link);
    } catch (err) {
      // Ignore local failures
    }
  };

  const markAllRead = async () => {
    try {
      await notificationApi.markAllRead();
      await loadNotifications();
    } catch (err) {
      // Ignore local failures
    }
  };

  return (
    <div className="notif-bell-wrap">
      <button
        type="button"
        className="notif-bell-btn"
        onClick={handleOpen}
        aria-label="Notifications"
      >
        <FaBell />
        {(unreadCount || unread) > 0 ? (
          <span className="notif-badge">{unreadCount || unread}</span>
        ) : null}
      </button>

      {open ? (
        <div className="notif-dropdown">
          <div className="notif-head">
            <strong>Notifications</strong>
            <button type="button" onClick={markAllRead}>Mark all read</button>
          </div>

          {loading ? <div className="notif-empty">Loading...</div> : null}
          {!loading && notifications.length === 0 ? (
            <div className="notif-empty">No notifications.</div>
          ) : null}

          <div className="notif-list">
            {notifications.slice(0, 10).map((n) => (
              <button
                key={n._id}
                type="button"
                className={`notif-item ${n.isRead ? "read" : "unread"}`}
                onClick={() => markAndNavigate(n)}
              >
                <div className="notif-title">{n.title}</div>
                <div className="notif-message">{n.message}</div>
              </button>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default NotificationBell;
